/**
 * Created by ivo on 03.02.17.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {formatElapsedTime} from "../../../../trans";

class NotificationListItem extends React.Component {
    static propTypes = {
        id: PropTypes.number.isRequired,
        level: PropTypes.string.isRequired,
        title: PropTypes.string,
        message: PropTypes.string.isRequired,
        timestamp: PropTypes.object.isRequired,
        currentTime: PropTypes.object
    };

    static defaultProps = {
        title: "",
        currentTime: new Date()
    };

    constructor(props) {
        super(props);
        this.hideNotification = this.hideNotification.bind(this);
    }
    hideNotification() {
        if (this.props.onHide) this.props.onHide(this.props.id);
    }

    getTheme(level) {
        switch (level) {
            case 'info':
                return "fa-info-circle";
            case 'success':
                return "fa-check-circle";
            case 'warning':
                return "fa-question-circle";
            case 'error':
                return "fa-exclamation-triangle";
            default:
                return "fa-circle";
        }
    }

    render() {
        return (
            <div>
                <i className={"fa fa-fw " + this.getTheme(this.props.level)}></i>
                <strong>{this.props.title || ""}</strong>
                {this.props.message}
                <span className="pull-right text-muted small">{formatElapsedTime(this.props.timestamp, this.props.currentTime)}</span>
            </div>
        )
    }
}

export default NotificationListItem;
